import { Injectable } from '@angular/core';
import { SortMeta } from '../interfaces';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SystemTableService {
  private sortSource = new Subject<SortMeta | null>();
  constructor() {}
  get sortSource$() {
    return this.sortSource.asObservable();
  }

  onSort(sortMeta: SortMeta | null) {
    this.sortSource.next(sortMeta);
  }
}
